import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {LoginComponent} from './pages/login/login.component';
import {HomeComponent} from './pages/home/home.component';
import {HeizungComponent} from './pages/details/heizung/heizung.component';
import {AuthGuard} from './guards/auth.guard';
import {WarmwasserComponent} from './pages/details/warmwasser/warmwasser.component';
import {KaltwasserComponent} from './pages/details/kaltwasser/kaltwasser.component';
import {ChangePasswordComponent} from './pages/change-password/change-password.component';
import {EditNotificationsComponent} from './pages/edit-notifications/edit-notifications.component';
import {ActivateAccountComponent} from './pages/activate-account/activate-account.component';
import {ResetPasswordComponent} from './pages/reset-password/reset-password.component';
import {ResetPasswordConfirmComponent} from './pages/reset-password-confirm/reset-password-confirm.component';

const routes: Routes = [
  {path: 'login', component: LoginComponent},
  {path: 'edit-notifications', component: EditNotificationsComponent},
  {path: 'home', component: HomeComponent,  canActivate: [AuthGuard]},
  {path: 'passwort-aendern', component: ChangePasswordComponent,  canActivate: [AuthGuard]},
  {path: 'passwort-zuruecksetzen', component: ResetPasswordComponent},
  {path: 'passwort-zuruecksetzen/bestaetigen', component: ResetPasswordConfirmComponent},
  {path: 'activate', component: ActivateAccountComponent},
  {path: 'heizung', component: HeizungComponent, canActivate: [AuthGuard]},
  {path: 'warmwasser', component: WarmwasserComponent, canActivate: [AuthGuard]},
  {path: 'kaltwasser', component: KaltwasserComponent, canActivate: [AuthGuard]},
  {path: '', redirectTo: '/login', pathMatch: 'full'},
  {path: '**', redirectTo: '/login'}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
